import axios from 'axios'
import { Notification } from 'element-ui'
import { getParams } from '@/utils/auth.js'
import Router from '@/router'
// 创建axios实例
/* eslint-disable */
const apiArr = [
  {
    // 搜索主入口
    service: null,
    baseURL: window.origin.includes('118') ? 'https://opensearchapi.xk.dacube.cn/' : '//opensearchapi.xk.dacube.cn/', // api 的 base_url
    //baseURL: 'http://118.118.118.10:8888/',
  },
  {
    // 搜索统计
    service: null,
    // baseURL: 'http://118.118.118.10:8888/',
    baseURL: window.origin.includes('118') ? 'https://apisearch.xk.dacube.cn/xkhomepage/' : '//apisearch.xk.dacube.cn/xkhomepage/'
  }
]

let flag = false
let database = getParams('database') ? decodeURIComponent(getParams('database')) : '贵州省数据库'

apiArr.map((v, index) => {
  v.service = axios.create({
    // eslint-disable-next-line
    baseURL: v.baseURL, // api 的 base_url
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      'database': encodeURIComponent(database),
      'level': getParams('level') || '1'
    }
  })
  // request拦截器
  v.service.interceptors.request.use(
    config => {
      // 设置请求头
      // config.headers.post['Content-type'] = 'application/json'
      // if (store.getters.token) {
      // config.headers['token'] = '' // 让每个请求携带自定义token 请根据实际情况自行修改
      // }
      return config
    },
    error => {
      // Do something with request error
      Notification.error({
        title: '失败',
        message: '接口异常，请稍后重试'
      })
      Promise.reject(error)
    }
  )

  // response 拦截器
  v.service.interceptors.response.use(
    response => {
      /**
       * 成功所需条件，失败则抛错
       */
      if (response.data.msg === 'SUCCESS' || response.data.code === 200) {
        flag = false
        return response.data
      } else if (response.data.code === 401) {
        // Notification.error({
        //   title: '失败',
        //   message: '登录过期，请重新登录'
        // })
        Router.replace('/login')
        localStorage.removeItem('token')
      }
      else {
        // error处理
        if (!flag) {
          Notification.error({
            title: '失败',
            message: (response.data.msg || response.msg) || '接口异常，请稍后重试'
          })
          flag = true
        }
        return Promise.reject(response.data)
      }
    },
    error => {
      if (!flag) {
        Notification.error({
          title: '失败',
          message: '接口异常，请稍后重试'
        })
        flag = true
      }
      console.log('err' + error) // for debug

      return Promise.reject(error)
    }
  )
})


let mainService = apiArr[0].service
let statisticsService = apiArr[1].service

export {
  mainService,
  statisticsService
}
